module.exports = __webpack_public_path__ + "static/media/09.89723853.jpg";